import axios from 'axios';
import { serverConfig } from './server-config';
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem("authToken");
            location.reload();
        }
        return Promise.reject(error);
    }
);

const BASE_URL = `https://${serverConfig.serverBaseAddress}/signite/job-listings`;

const JobListingService = {

    getAllJobs(pageNo = 0, pageSize = 6) {
        return axios.get(
            `${BASE_URL}/get/all?pageNo=${pageNo}&pageSize=${pageSize}`,
            {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("authToken"),
                },
            }
        );
    },

    getJobsByStatus(status, pageNo = 0, pageSize = 6) {
        return axios.get(
            `${BASE_URL}/get/list/${status}?pageNo=${pageNo}&pageSize=${pageSize}`,
            {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("authToken"),
                },
            }
        );
    },

    addJob(job) {
        return axios.post(
            `${BASE_URL}/add`,
            job,
            {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("authToken"),
                },
            }
        );
    },

    updateJob(id, job) {
        return axios.post(
            `${BASE_URL}/update/${id}`,
            job,
            {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("authToken"),
                },
            }
        );
    },

    closeJob(id, listedByLeaderly = false) {
        return axios.post(
            `${BASE_URL}/close/${id}?listedByLeaderly=${listedByLeaderly}`,
            {},
            {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("authToken"),
                },
            }
        );
    },

    reopenJob(id) {
        return axios.post(
            `${BASE_URL}/reopen/${id}`,
            {},
            {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("authToken"),
                },
            }
        );
    },

    getMatchingJobs: (page = 0, size = 10) => {
        return axios.get(
            `https://${serverConfig.serverBaseAddress}/signite/job-listings/candidate/get/matching?pageNo=${page}&pageSize=${size}`, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('authToken'),
            },
        }
        );
    },

    getAllCandidateJobs: (page = 0, size = 10) => {
        return axios.get(
            `https://${serverConfig.serverBaseAddress}/signite/job-listings/candidate/get/all?pageNo=${page}&pageSize=${size}`, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('authToken'),
            },
        }
        );
    },

    getAppliedJobs: (page = 0, size = 10) => {
        return axios.get(
            `https://${serverConfig.serverBaseAddress}/signite/job-applications/applied-jobs?page=${page}&size=${size}`, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('authToken'),
            },
        }
        );
    },

    getApplicants: (jobListingId, page = 0, size = 10, name = "") => {
        return axios.get(`https://${serverConfig.serverBaseAddress}/signite/job-applications/${jobListingId}/applicants?page=${page}&size=${size}&name=${name}`, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('authToken'),
            },
        });
    },

    searchJobs: (filters, page = 0, size = 10) => {
        return axios.post(
            `https://${serverConfig.serverBaseAddress}/signite/job-listings/candidate/search`,
            {
                page,
                size,
                functions: filters.function
                    ? [
                        {
                            fieldValue: filters.function,
                            subcategory: filters.functionSubCategory,
                        },
                    ]
                    : [],
                industrySubcategories: filters.industry
                    ? [
                        {
                            fieldValue: filters.industry,
                            subcategory: filters.industrySubCategory,
                        },
                    ]
                    : [],
            },
            {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("authToken"),
                },
            }
        );
    },

    applyJob: (jobListingId) => {
        return axios.post(
            `https://${serverConfig.serverBaseAddress}/signite/job-applications/apply`,
            {
                jobListingId,
            },
            {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("authToken"),
                },
            }
        );
    },
};

export default JobListingService;